import { render } from "./_invite.vue?vue&type=template&id=395872bd&scoped=true"
import script from "./_invite.vue?vue&type=script&lang=js"
export * from "./_invite.vue?vue&type=script&lang=js"

import "./_invite.vue?vue&type=style&index=0&id=395872bd&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395872bd"]])

export default __exports__